// @ts-nocheck
import dayjs, { Dayjs } from 'dayjs';

export const formatDate = (filters, filterKey):  {[p: string]: Dayjs} => {
    const date = new Date(filters[filterKey]).toLocaleDateString().replaceAll('.', '-');
    const formattedDate = dayjs(date, 'DD.MM.YYYY').format('DD.MM.YYYY');
    return filters[filterKey] ? { [filterKey]: formattedDate } : {};
};
